import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const DataTableWidget: WidgetRegistryEntry = {
  name: "DataTable",
  configuration: () => import("./configuration").then((m) => m.Configuration),
  component: () => import("./data-table-widget.component").then((m) => m.DataTableWidgetComponent)
};
